import { useState } from 'react'
import {
	EuiButton,
	EuiButtonIcon,
	EuiModalBody,
	EuiModalFooter,
} from '@equipmentshare/ds2'
import ProviderPicker from 'components/ProviderPicker'
import { Provider } from 'graphql'

import styles from './merge-providers-form.module.css'

export type MergeProvidersFormProps = {
	onCancel: () => void,
	onSubmit: ( goodProviderId: number, duplicateProviderId: number ) => Promise<any>,
	onSuccess: () => void,
	selectedProvider: Provider,
}

export default function MergeProvidersForm( { onCancel, onSubmit, onSuccess, selectedProvider }: MergeProvidersFormProps ) {
	const [ goodProvider, setGoodProvider ] = useState<Provider | undefined>( selectedProvider )
	const [ duplicateProvider, setDuplicateProvider ] = useState<Provider | undefined>()
	const [ isSaving, setIsSaving ] = useState( false )

	const handleSelectGoodProvider = ( _: any, provider?: Provider ) => setGoodProvider( provider )
	const handleSelectDupeProvider = ( _: any, provider?: Provider ) => setDuplicateProvider( provider )

	const handleSwap = () => {
		setDuplicateProvider( goodProvider )
		setGoodProvider( duplicateProvider )
	}

	const handleSubmit = async() => {
		if ( goodProvider && duplicateProvider ) {
			setIsSaving( true )
			await onSubmit( goodProvider.id, duplicateProvider.id )
			setIsSaving( false )
			onSuccess()
		}
	}

	const isValid = goodProvider && duplicateProvider

	return (
		<>
			<EuiModalBody>
				<ProviderPicker
					id="goodPart"
					label="Good Manufacturer"
					onChange={handleSelectGoodProvider}
					selectedProvider={goodProvider}
					required
				/>
				<EuiButtonIcon
					id="swapBtn"
					aria-label="Swap"
					className={styles.swapButton}
					onClick={handleSwap}
					color="text"
					size="m"
					iconSize="xl"
					iconType="merge"
					title="Swap"
				/>
				<ProviderPicker
					id="duplicatePart"
					label="Duplicate Manufacturer"
					onChange={handleSelectDupeProvider}
					selectedProvider={duplicateProvider}
					required
				/>

				<div className={styles.warningContainer}>
					<div className={styles.warning}>
						Warning: the duplicate manufacturer will be removed, and the good manufacturer selected above will take over its assignments.
					</div>
					<div className={styles.warningBold}>
						This action cannot be undone!
					</div>
				</div>
			</EuiModalBody>
			<EuiModalFooter>
				<EuiButton
					id="cancelBtn"
					color="text"
					onClick={onCancel}
				>
          Cancel
				</EuiButton>
				<EuiButton
					id="submitBtn"
					fill
					isDisabled={!isValid}
					isLoading={isSaving}
					onClick={handleSubmit}
				>
          Submit
				</EuiButton>
			</EuiModalFooter>
		</>
	)
}
